import Flex from 'frontend/commons/Flex';
import SlickImageGallery from 'frontend/commons/slick-image-gallery';

const ImageGallery = ({ title, items, label }) => {
  if (!items.length === 0) return;
  return (
    <Flex vertical className="card-box package-information__gallery">
      <Flex vertical className="package-information__gallery__header">
        {label ? <p className="package-information__hotel-subtitle">{label}</p> : ''}
        <h3 className="text-lg package-information__hotel-title">{title.toLowerCase()}</h3>
      </Flex>
      <SlickImageGallery items={items} />
    </Flex>
  );
};

export default ImageGallery;
